'use client';

import Image from 'next/image';
import { cn } from '@bazaar-marketplace/utils';

import { goodieCardVariants } from './variants';
import type { GoodieCardProps } from './types';

export const GoodieCard = ({ title, className, previewImage, ...props }: GoodieCardProps) => (
  <div className={cn(goodieCardVariants(), className)} {...props}>
    <div className="flex gap-1 w-fit h-fit">
      <div className="w-3 h-3 bg-[#747578] rounded-2xl border border-white/15" />
      <div className="w-3 h-3 bg-[#F7A4B4] rounded-2xl border border-white/15" />
      <div className="w-3 h-3 bg-[#5DA0DC] rounded-2xl border border-white/15" />
      <div className="w-3 h-3 bg-[#71C878] rounded-2xl border border-white/15" />
      <div className="w-3 h-3 bg-[#A27FEC] rounded-2xl border border-white/15" />
    </div>

    <div className="flex-1 w-full rounded-2xl flex items-start justify-center">
      <div className="size-28 rounded-2xl relative overflow-hidden">
        <Image alt="Goodie" className="size-full" height={100} src={previewImage ?? ''} width={100} />
        {/* <div className="w-full h-full flex items-center justify-center">
          <span className="text-gray-500 text-sm font-bold">Goodie</span>
        </div> */}
      </div>
    </div>

    <div className="flex flex-col justify-end items-center w-full">
      <h3 className="text-white text-lg font-bold font-quicksand text-center">{title}</h3>
    </div>
  </div>
);
